/* eslint-disable import/prefer-default-export */
import api from '../api';

export function createCompanyAddress({ companyId, address }) {
  return api.post(`/companies/${companyId}/addresses`, address);
}
